import CardMedia from '../../../../layouts/Card/cardContent/CardMedia';

export const listSettings = {
    grid: {
        components: CardMedia,
        columns: {
            xs: 1,
            sm: 2,
            laptop: 4,
        },
        layout:{
            spacing:2,
            padding: "40px 0 0 0"
        }
    },
}

export const listMappers = [
    {
        view: 'card',
        mapper: null
    },
    // {
    //     view : 'table',
    //     mapper : 'companiesListMapper'
    // }
]

export const perPageOptions = {
    'card': [12, 24],
}
